import dayjs from "dayjs";

// BUG-2171: a till opened after the previous day's store close (NXT post-close
// sales) is stamped with the *next* business date while its openingTime is
// still the previous evening. Day-change checks must compare the business
// date, not the wall-clock opening date — otherwise that session is treated
// as "yesterday's" the next morning and the store-day gets closed early.
// Sessions without businessDate (opened before it was stamped) fall back to
// the openingTime date, which is the old behaviour.
export const getTillBusinessDate = (tillEvent) =>
  tillEvent?.businessDate ? dayjs(tillEvent.businessDate).format("YYYY-MM-DD") : tillEvent?.openingTime?.split(" ")[0] || null;

// A session stamped with a business date is past only once that date is behind
// today. A session without one keeps the old rule — any opening date other than
// today — so a till opened while the device clock was a day ahead is still sent
// to close once the clock is corrected, instead of running on under tomorrow's date.
export const isPastBusinessDay = (tillEvent) => {
  const businessDate = getTillBusinessDate(tillEvent);
  if (!businessDate) return false;
  const today = dayjs().format("YYYY-MM-DD");
  return tillEvent.businessDate ? businessDate < today : businessDate !== today;
};
